const META_PIXEL_ID = '1715709876227103'

type MetaPixelFunction = ((...args: unknown[]) => void) & {
  queue?: unknown[][]
  loaded?: boolean
  version?: string
}

type MetaWindow = Window & {
  fbq?: MetaPixelFunction
  _fbq?: MetaPixelFunction
  __avanzaMetaPixelInitialized?: boolean
}

export function initializeMetaPixel() {
  if (typeof window === 'undefined') return

  const metaWindow = window as MetaWindow

  if (metaWindow.__avanzaMetaPixelInitialized) return

  let fbq = metaWindow.fbq

  if (!fbq) {
    const queue: unknown[][] = []
    fbq = Object.assign(
      (...args: unknown[]) => {
        queue.push(args)
      },
      {
        queue,
        loaded: true,
        version: '2.0',
      },
    )

    metaWindow.fbq = fbq
    metaWindow._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  fbq('init', META_PIXEL_ID)
  fbq('track', 'PageView')
  metaWindow.__avanzaMetaPixelInitialized = true
}

export function trackInitiateCheckout() {
  if (typeof window === 'undefined') return

  const metaWindow = window as MetaWindow
  metaWindow.fbq?.('track', 'InitiateCheckout', {
    content_name: 'Pensamientos Fuera de Serie',
    currency: 'UYU',
    value: 990,
  })
}
